export const DIGIT_REGEX = /^[0-9]*$/g;
export const CRYPTO_ADDRESS_REGEX = /^[a-zA-Z0-9]{32,44}$/;
export const COMMA_SEPERATED_NUMBER_REGEX = /^[0-9,.]*$/g;
export const EMAIL_REGEX = '/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/';
